import { type RecordingPlaybackInput, type RecordingPlaybackSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { recordingPlaybackKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useRecordingPlayback({
  recordingId,
}: RecordingPlaybackInput): GetHookResponse<RecordingPlaybackSuccess> {
  return useTantalimQuery<RecordingPlaybackInput, RecordingPlaybackSuccess, RecordingPlaybackSuccess>({
    url: '/recording/playback',
    queryKey: recordingPlaybackKey(recordingId),
    input: { recordingId },
    convertResponse: (responseData) => {
      return responseData
    },
    options: {
      retry: (failureCount, error) => error.error.retry === true && failureCount < 60,
      retryDelay: 5_000,
    },
  })
}
